var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","absolute":"","dark":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('p',[_vm._v(" "+_vm._s(_vm.year)+" © COVID-19 Tracking Website. Built by Philaphonh Inthavongsa ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }